import React, { ReactNode } from "react";
import { ReportDataWrapperHead } from "../ReportStyles/ReportWrappers";
import { ReportH4 } from "../ReportStyles/Text";
import { BuxTooltip } from "../../Common";

interface ChartTitleProps {
  titleText: string;
  tooltipText?: string | ReactNode | JSX.Element;
}

export const ChartTitle = (props: ChartTitleProps) => {
    const { titleText, tooltipText } = props;
    return (
        <ReportDataWrapperHead>
            <div style={{ width: "100%" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <ReportH4 style={{ margin: "0", fontSize: "14px", height: "17px" }}>
                        {titleText}
                    </ReportH4>
                    {tooltipText && (
                        <BuxTooltip
                            placement="left"
                            content={tooltipText}
                            trigger="click"
                            allowClickThrough={false}
                            iconSize={14}
                        />
                    )}
                </div>
            </div>
        </ReportDataWrapperHead>
    );
};
